import GlobalFooter from '@/components/shared/global-footer/GlobalFooter.vue';
import GlobalHeader from '@/components/shared/global-header/GlobalHeader.vue';
import ScrollToTopButton from '@/components/shared/scroll-to-top-button/ScrollToTopButton.vue';
import router from '@/routers';
import 'bootstrap/dist/js/bootstrap.bundle';
import { createApp } from 'vue';
import '../controllers';

/**
 * @param {string} selector
 * @param {import('vue').Component} component
 * @param {{ useRouter?: boolean }} [options]
 */
const mountIfExists = (selector, component, options = {}) => {
  const el = document.querySelector(selector);
  if (!el) return;
  const { loggedIn, userName } = /** @type {HTMLElement} */ (el).dataset || {};
  const props = {
    isLoggedIn: loggedIn === 'true',
    userName,
  };
  const app = createApp(component, props);
  if (options.useRouter) {
    app.use(router);
  }
  app.mount(el);
};

const mountGlobalShell = () => {
  mountIfExists('#global-header-vue', GlobalHeader, { useRouter: true });
  mountIfExists('#global-footer-vue', GlobalFooter);
  mountIfExists('#scroll-to-top-button-vue', ScrollToTopButton);
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', mountGlobalShell);
} else {
  mountGlobalShell();
}
